import { get, patch, post, remove } from '@/api/base'

const sitesApi = {
  get: async siteUuid => {
    const response = await get({
      path: `sites/${siteUuid}`,
    })
    return response.success ? response.data.site : null
  },
  getAll: async params => {
    const response = await get({ path: 'sites', params })
    return response.success
      ? {
          ...response,
          sites: response.data.sites,
          pagination: response.data.meta.pagination,
        }
      : response
  },
  getAllForCompany: async companyUuid => {
    const response = await get({
      path: 'sites',
      params: { company_uuid: companyUuid },
    })
    return response.success ? response.data.sites : []
  },
  update: async (siteUuid, updateDetails) => {
    const response = await patch({
      path: `sites/${siteUuid}`,
      params: updateDetails,
    })
    return response.success ? response.data.site : null
  },
  create: async params => {
    const response = await post({
      path: `sites`,
      params,
    })
    return response.success ? response.data.site : null
  },
  delete: async siteUuid => {
    return await remove({
      path: `sites/${siteUuid}`,
    })
  },
}

export default sitesApi
